// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3pdip","errorLogs":"styles_errorLogs__1cQqV"};